import { render } from "./BrandShowcase.vue?vue&type=template&id=708d6aa6&scoped=true"
import script from "./BrandShowcase.vue?vue&type=script&lang=js"
export * from "./BrandShowcase.vue?vue&type=script&lang=js"

import "./BrandShowcase.vue?vue&type=style&index=0&id=708d6aa6&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-708d6aa6"]])

export default __exports__